import { render, staticRenderFns } from "./NotesPage.vue?vue&type=template&id=62dc7956"
import script from "./NotesPage.vue?vue&type=script&lang=js"
export * from "./NotesPage.vue?vue&type=script&lang=js"
import style0 from "./NotesPage.vue?vue&type=style&index=0&id=62dc7956&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports